/* eslint-disable max-len */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, firstValueFrom, forkJoin } from 'rxjs';
import { DetailAlamat } from 'src/app/interfaces/api/alamat';
import { Warehouse } from 'src/app/interfaces/api/product';
import { THTransaction, TransactionDetail } from 'src/app/interfaces/api/transaction';
import { ProductService } from 'src/app/services/product.service';
import { ProfileService } from 'src/app/services/profile.service';
import * as ApiAlamat from '../../interfaces/api/alamat';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { CheckoutItem } from 'src/app/pages/checkout/checkout.page';
import { CartService } from 'src/app/services/cart.service';
import { Preferences } from '@capacitor/preferences';
import { City } from 'src/app/interfaces/api/city';
import { CartsData } from 'src/app/interfaces/api/cart';
import { encodeQueryParam, transformWeight } from 'src/helpers';

// import { THTransaction } from 'src/app/interfaces/api/transaction';
export interface Product {
  id: number;
  image_url: string;
  name: string;
  qty: number;
  weight: number;
  price_after_discount?: number;
}

export interface TransactionItem {
  id: number;
  status: number;
  category_name: string;
  created_at: string;
  price_total: number;
  products: Product[];
}
@Component({
  selector: 'app-card-transaksi',
  templateUrl: './card-transaksi.component.html',
  styleUrls: ['./card-transaksi.component.scss'],
})
export class CardTransaksiComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() transaction: THTransaction;
  @Output() addedToCart = new EventEmitter();

  productThumbnail: TransactionDetail;
  warehouse: Warehouse;
  deliveryAddress: DetailAlamat;
  expiredDate: string;
  timeRemining: number; //detik
  weight: string;

  constructor(
    private productService: ProductService,
    private profileService: ProfileService,
    private router: Router,
    private cartService: CartService,
    private toastController: ToastController,
  ) {}

  ngOnInit() {
    if (!this.isLoading) {
      this.productThumbnail = this.transaction.detail[0];
      this.weight = transformWeight(this.productThumbnail?.product?.weight);
      this.getExpiredDate(this.transaction?.updated_at);
    }
    this.loadData(null);
  }

  async loadData(event: any) {
    if (!this.transaction) {
      return;
    }

    this.isLoading = true;
    const warehouseReq = this.productService.getWarehouseList();

    let activeAddressReq: Observable<ApiAlamat.GetShowRequestBody>;

    if (this.transaction.delivery_type === 0) {
      activeAddressReq = this.profileService.detailAlamat(this.transaction.id_md_customer_address.toString());
    }

    activeAddressReq = this.profileService.getActiveAlamat();

    forkJoin([warehouseReq, activeAddressReq]).subscribe({
      next: async ([warehouseRes, activeAddressRes]) => {
        const warehousesObj = { ...warehouseRes.warehouses };
        let warehouses: Warehouse[] = [];

        for (const array of Object.values(warehousesObj)) {
          warehouses = warehouses.concat(array);
        }

        this.warehouse = warehouses.find(w => w.id === this.transaction?.warehouse?.id);
        this.deliveryAddress = activeAddressRes.customer_address;
      },
      complete: () => {
        this.isLoading = false;
        event?.target?.complete();
      },
    });
  }

  getExpiredDate(created_date: string) {
    const expiredDateMs = new Date(created_date).getTime() + 86400000; //24 jam (86400000 ms) setelah created_date.
    const todayMs = new Date().getTime();
    const expiredDate = new Date(expiredDateMs);

    this.expiredDate = expiredDate.toISOString();
    this.timeRemining = Math.round((expiredDateMs - todayMs) / 1000);
  }

  onAddedToCart(image_url: string) {
    this.addedToCart.emit(image_url);
  }

  async onAddToCart(event) {
    event.stopPropagation();
    // console.log({ detail: this.transaction.detail, transaction: this.transaction });

    const selectedCity = JSON.parse((await Preferences.get({ key: 'selectedCity' })).value) as City;
    const cartCollectionReq = this.cartService.getCartCollection();

    let cartCollection: CartsData[] = [];
    let someItemIsNoStock = false;

    try {
      cartCollection = (await firstValueFrom(cartCollectionReq)).carts;
    } catch (error) {
      console.log(error);
      return;
    }

    for (const transactionProduct of this.transaction.detail) {
      const productDetailReq = this.productService.getSingleProduct(
        transactionProduct.id_mh_product.toString(),
        selectedCity.id.toString(),
      );

      const warehouseId = this.transaction.id_mh_warehouse;
      let ready_stock = 0;

      try {
        const product = (await firstValueFrom(productDetailReq)).product;
        ready_stock = product.MdStock.find(stock => stock.id_mh_warehouse === warehouseId).ready_stock;
      } catch (error) {
        console.log({ error });
        continue;
      }

      // if order amount bigger than stock then skip
      if (transactionProduct.product_amount > ready_stock) {
        someItemIsNoStock = true;
        continue;
      }

      // if product already in cart then add amount
      if (cartCollection.some(cart => cart.id_mh_product === transactionProduct.id_mh_product)) {
        this.proceedAddQtyToCart(transactionProduct.id_mh_product, transactionProduct.product_amount, warehouseId, () =>
          this.onAddedToCart(this.productThumbnail.product.image_url),
        );
      } else {
        this.proceedAddToCart(transactionProduct.id_mh_product, transactionProduct.product_amount, warehouseId, () =>
          this.onAddedToCart(this.productThumbnail.product.image_url),
        );
      }
    }

    if (someItemIsNoStock) {
      this.presentToast(
        this.transaction.detail.length > 1 ? 'Beberapa produk tidak tersedia' : 'Produk tidak tersedia',
        1500,
        'primary',
      );
    }
  }

  proceedAddToCart(productId: number, qty: number, warehouseId: number, callback: () => void = () => {}) {
    this.cartService.addToCart(productId, qty, warehouseId).subscribe({
      next: addToCartRes => {
        console.log(addToCartRes);
      },
      complete: () => callback(),
    });
  }

  proceedAddQtyToCart(productId: number, qty: number, warehouseId: number, callback: () => void = () => {}) {
    this.cartService.addToCartAddMinus(productId, qty, warehouseId).subscribe({
      next: addToCartRes => {
        console.log(addToCartRes);
      },
      complete: () => callback(),
    });
  }

  // getCountCart() {
  //   this.cartService.getCartCount().subscribe({
  //     next: res => {
  //       this.cartCount = res.count;
  //     },
  //   });
  // }

  async onCheckout(event) {
    event.stopPropagation();

    const cityId = this.transaction.warehouse.id_mh_city.toString() ?? '153';
    const productIds = this.transaction.detail.map(t => t.product.id.toString());

    let stocks: number[] = [];
    let stockIsReady = false;

    forkJoin(productIds.map(id => this.productService.getSingleProduct(id, cityId))).subscribe({
      next: val => {
        stocks = val.map(p => p.product.ready_stock);
      },
      complete: () => {
        stockIsReady = stocks.every(p => p > 0);

        if (!stockIsReady) {
          this.presentToast(
            'salah satu barang dari transaksi ini sedang tidak tersedia. silahkan cek katalog kami di beranda untuk melihat barang lainnya!',
            3000,
            'danger',
          );
          return;
        }

        const checkoutItems: CheckoutItem[] = [];

        for (const detail of this.transaction?.detail) {
          checkoutItems.push({
            id_mh_warehouse: this.warehouse.id,
            cartId: null,
            product: { ...detail.product, id_mh_warehouse: this.transaction.id_mh_warehouse },
            qty: detail.product_amount,
          });
        }

        const queryParams = {
          checkoutItems: encodeQueryParam(checkoutItems),
        };

        this.router.navigate(['/checkout'], { queryParams });
        // this.router.navigate(['/checkout'], {
        //   state: {
        //     data: {
        //       checkoutItems: JSON.stringify(checkoutItems),
        //     },
        //   },
        // });
      },
      error: () => {
        this.presentToast('something went wrong!', 1000, 'danger');
      },
    });
  }

  getSimpleStatus() {
    if (this.transaction?.delivery_type !== 1) {
      return this.transaction?.simple_status;
    }

    if (this.transaction?.status === 3) {
      return 'Barang disiapkan';
    } else if (this.transaction?.status === 4) {
      return 'Siap diambil';
    } else {
      return this.transaction?.simple_status;
    }
  }

  protected async presentToast(message: string, duration: number = 1000, color: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
      color: color ?? 'warning',
    });
    return await toast.present();
  }
}
